export const SEARCH_EXTENSION_DESKTOP_BASE_URL = 'https://www.booking.com';
export const SEARCH_EXTENSION_MOBILE_BASE_URL = 'https://sp.booking.com';
export const SEARCH_EXTENSION_IFRAME_ROUTE = '/booking';
export const SEARCH_EXTENSION_MAX_UPDATE = 1;
export const SEARCH_EXTENSION_MAX_TOUCHPOINT_ACTIVE_DURATION = 1000;
export const SEARCH_EXTENSION_TOUCHPOINT_KEY = 'searchExtensionTouchpoint';
export const SEARCH_EXTENSION_KEY = 'searchExtension';
